{
  "login": {
    "title": "Welcome back",
    "lead": "Sign in with the email you used to buy Baby Plan.",
    "email": "Email",
    "password": "Password",
    "submit": "Sign in",
    "forgot": "Forgot password?",
    "help": "Bought Baby Plan but can't sign in? Check the email with your password, or write to support@getbabyplan.com.",
    "helpLink": "Sign-in help"
  },
  "forgot": {
    "title": "Reset your password",
    "lead": "We'll email you a link to set a new password.",
    "submit": "Send the link",
    "sent": "If an account exists for {{email}}, the link is on its way. It works for one hour.",
    "back": "Back to sign in"
  },
  "reset": {
    "title": "Set a new password",
    "password": "New password",
    "hint": "At least 8 characters.",
    "submit": "Save password",
    "saved": "Your password is saved.",
    "toLogin": "Sign in",
    "badLink": "This link has expired or was already used. Ask for a new one."
  },
  "errors": {
    "invalid_credentials": "That email and password don't match. Check them or reset your password.",
    "too_many_attempts": "Too many attempts. Wait a few minutes and try again.",
    "crm_unavailable": "We can't sign you in right now. Try again in a minute.",
    "offline": "You're offline. Connect to the internet to sign in.",
    "invalid_token": "This link has expired or was already used. Ask for a new one.",
    "validation_error": "Check the fields and try again.",
    "generic": "Something went wrong. Try again."
  }
}
